import { render, staticRenderFns } from "./DashBoardLogistica.vue?vue&type=template&id=5eccd825&"
import script from "./DashBoardLogistica.vue?vue&type=script&lang=js&"
export * from "./DashBoardLogistica.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardLogistica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports